import { array, boolean, minValue, number, object, picklist, pipe, string } from "valibot";

export const pageSize = 30;

export const feisFiltersSchema = object({
	hasExam: boolean(),
	regionIds: array(string()),
	registrationOpen: boolean(),
	search: string(),
	sort: picklist(["date", "series"]),
	worldQualifier: boolean(),
});

export const feisListRequestSchema = object({
	...feisFiltersSchema.entries,
	page: pipe(number(), minValue(0)),
});
